import type { FaireProductEntity } from "../../entity_types/product";

export const p_7bnmjdrvwe: FaireProductEntity = {
  token: "p_7bnmjdrvwe",
  type: "product",
  name: "MegaSnax Neon Bears with Chili and Chamoy",
  brandToken: "b_7p5vnswqfb",
  brandName: "MEGASNAX",
  imageUrl:
    "https://cdn.faire.com/fastly/bd7428588477274d95c4f098ad71fb96bdc7eb591ce14f3021f0a976e3fd17c3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cf1ec4e7c07a76622a9b8052acaf62800dcca023b71e4d9fd96a75c0b4d6dd5.jpeg",
  ],
  priceDollars: 2.31,
  description:
    'MegaSnax Neon Bears with Chili and Chamoy are a unique Mexican-style candy that offers an intense blend of sweet, sour, salty, and spicy flavors. These treats feature soft, chewy gummy bears that have been coated in a tangy chamoy sauce and a dusting of chili seasoning. \n\nFlavor and Texture Profile\n\nComplex Taste: The candy delivers a "flavor explosion" that hits multiple taste profiles in one bite. It starts with the sweet and sour fruit flavor of the neon gummy bear, followed by the savory and salty tang of the chamoy, and finishes with a distinct kick of chili heat.\nDual Texture: The core is a soft, elastic, and satisfyingly chewy gummy bear. This texture is enhanced by the moist, sticky coating of the chamoy sauce and the slightly coarse, powdery texture of the chili seasoning. \n\nKey Product Details\n\nAppearance: The bears are brightly colored in "neon" assortment (e.g., yellow, red, blue, green) but are thoroughly saturated with the reddish-brown chamoy and chili mix, giving them a vibrant, coated appearance.\n\nThis product is an excellent choice for those who enjoy bold and unique flavor combinations, blending a classic American candy with authentic Mexican dulces enchilados (spicy candies). ',
  tags: [],
  msrpDollars: 4.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:38.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
